import * as z from "zod";

/** A GitHub event a waiting session resumes on, e.g. the merge of `acme/web#42` or its CI settling. */
export type AwaitedGithubEvent = z.infer<typeof AwaitedGithubEvent>;
export const AwaitedGithubEvent = z.object({
  /** The wait's id, which cancels it. */
  id: z.string(),
  /** `closed`: the PR merges or closes. `ci_settled`: every check on its newest head finishes. */
  // A backend still on the previous deploy omits it, and its waits are all `closed`.
  event: z.enum(["closed", "ci_settled"]).default("closed"),
  repository: z.string(),
  pr_number: z.number(),
  url: z.string(),
});
